import { render, staticRenderFns } from "./addCustomDocDialog.vue?vue&type=template&id=5ace920f&scoped=true"
import script from "./addCustomDocDialog.vue?vue&type=script&lang=js"
export * from "./addCustomDocDialog.vue?vue&type=script&lang=js"
import style0 from "./addCustomDocDialog.vue?vue&type=style&index=0&id=5ace920f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ace920f",
  null
  
)

export default component.exports